export const locKeys = {
  destAirportName: "flights.structuredTable.destAirportName",
  originAirportName: "flights.structuredTable.originAirportName",
  flightsLowestPrice: "flights.structuredTable.flightsLowestPrice",
  distance: "flights.structuredTable.distance",
  originCityName: "flights.structuredTable.originCityName",
  destCityName: "flights.structuredTable.destCityName",
  destinationAirportIATACode: "flights.structuredTable.destinationAirportIATACode",
  originAirportIATACode: "flights.structuredTable.originAirportIATACode",
  popularAirline: "flights.structuredTable.popularAirline",
  averageFlightTime: "flights.structuredTable.averageFlightTime",
  noOfAirlinesServing: "flights.structuredTable.noOfAirlinesServing",
  noOfFlightOptions: "flights.structuredTable.noOfFlightOptions",
  flightsAirlineNames: "flights.structuredTable.flightsAirlineNames",
  title: "flights.structuredTable.title",
  hoursMinutes: "flights.structuredTable.hours.minutes",
  hours: "flights.structuredTable.hours",
  minutes: "flights.structuredTable.minutes",
  airportCode: "flights.structuredTable.airportCode",
  country: "flights.structuredTable.country",
  airportName: "flights.structuredTable.airportName",
  flightCount: "flights.structuredTable.flightCount",
  flightCountTitle: "flights.flightCount.title",
  teaser: "flights.flightCount.teaser",
};
